import AxiosWrapper from "./AxiosWrapper"

export default class ShapesAPI extends AxiosWrapper {
  protected static getApiUrl(){
    return process.env.REACT_APP_SHAPES_URL
  }
}
